module.exports = __webpack_public_path__ + "static/video-player-d3ff13315c500e127c8e7ca4e974d72e.png";